<div class="contract-dialog">
  <div class="dialog-header">
    <h2>Prévisualisation et édition des contrats</h2>
    <button type="button" class="close-btn" (click)="close()">&times;</button>
  </div>

  @if (loadingFreshData) {
    <div class="loading-overlay">
      <div class="pdf-loader">Chargement des données de la mission...</div>
    </div>
  } @else {

  <mat-tab-group (selectedIndexChange)="onTabChange($event)" class="contract-tabs">
    <mat-tab>
      <ng-template mat-tab-label>
        Contrat Mission
        @if (missionContractSent) {
          <span class="sent-badge" title="Contrat envoyé">✓</span>
        }
      </ng-template>
      <div class="tab-body">
        <div class="left-pane" [formGroup]="missionForm" style="display: flex; flex-direction: column; min-height: 0;">
          <div style="flex: 1; overflow-y: auto; padding-bottom: 10px;">
          <h3>Modifier les informations du contrat</h3>

          @if (missionContractSent) {
            <div class="sent-notice">
              @if (missionContractSigned) {
                ✅ Ce contrat a été signé !
              } @else {
                ✅ Ce contrat a déjà été validé et envoyé.
              }
            </div>

            @if (!missionContractSigned) {
            <div class="reminder-panel">
              <div class="reminder-title">🔔 Rappels — Contrat Mission</div>
              <label class="reminder-toggle">
                <input type="checkbox" [(ngModel)]="missionReminderEnabled"
                  [ngModelOptions]="{standalone: true}" />
                <span>Rappels automatiques activés</span>
              </label>
              @if (missionReminderEnabled) {
                <div class="reminder-row">
                  <label class="reminder-interval">
                    <span>Prochain rappel dans</span>
                    <input type="number" min="1" max="720"
                      [(ngModel)]="missionNextSendInHours"
                      [ngModelOptions]="{standalone: true}"
                      class="interval-input" />
                    <span>h</span>
                  </label>
                  <span class="reminder-next-date">
                    ({{ getNextReminderDate('MISSION') | date:'dd/MM HH:mm' }})
                  </span>
                </div>
              }  
              @if (missionReminderEnabled) {
              <!-- <div class="reminder-row">
                <label class="reminder-interval">
                  <span>Ensuite, toutes les</span>
                  <input type="number" min="1" max="720"
                    [(ngModel)]="missionReminderIntervalHours"
                    [ngModelOptions]="{standalone: true}"
                    class="interval-input" />
                  <span>h</span>
                </label>
              </div> -->
              }
              <div class="reminder-actions" *ngIf="canAct">
                <button type="button" class="btn btn-secondary btn-sm"
                  [disabled]="savingMissionReminder"
                  (click)="saveReminderConfig('MISSION')">
                  {{ savingMissionReminder ? 'Sauvegarde...' : 'Enregistrer' }}
                </button>
                <button type="button" class="btn btn-primary btn-sm"
                  [disabled]="sendingMissionReminder"
                  (click)="sendReminderNow('MISSION')">
                  {{ sendingMissionReminder ? 'Envoi...' : 'Envoyer maintenant' }}
                </button>
              </div>
              @if (missionLastReminderSentAt) {
              <div class="reminder-last-sent">
                Dernier rappel : {{ missionLastReminderSentAt | date:'dd/MM/yyyy HH:mm' }}
              </div>
              }
            </div>
            }
          }

          <details class="form-section" open>
            <summary>Mission</summary>
            <label>
              <span>Référence / Titre</span>
              <input type="text" formControlName="missionTitle" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <label>
              <span>Qualification (poste)</span>
              <input type="text" formControlName="missionTypeDePoste" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <label>
              <span>Rémunération nette proposée</span>
              <input type="number" formControlName="compensationproposednet" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <!-- Dates hidden in contract edition (UI HIDE ONLY per specs) -->
            <div class="row" style="margin: unset; display: none;">
              <label>
                <span>Date de début</span>
                <input type="date" formControlName="startdate" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Date de fin</span>
                <input type="date" formControlName="enddate" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
            <div class="row" style="margin: unset;">
              <label>
                <span>Heure de début</span>
                <input type="time" formControlName="starttime" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Heure de fin</span>
                <input type="time" formControlName="endtime" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
            <label>
              <span>Description</span>
              <textarea rows="3" formControlName="description" [readonly]="missionContractSent || isCas1Doctor"></textarea>
            </label>
            <label>
              <span>Législation Rémunération</span>
              <textarea rows="5" formControlName="remunerationLegislation" [readonly]="missionContractSent || isCas1Doctor"></textarea>
            </label>
          </details>

          <details class="form-section">
            <summary>Établissement utilisateur</summary>
            <label>
              <span>Nom</span>
              <input type="text" formControlName="etablissementName" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <label>
              <span>Adresse</span>
              <input type="text" formControlName="etablissementAdress" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Code postal</span>
                <input type="text" formControlName="etablissementCodePostale" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Ville</span>
                <input type="text" formControlName="etablissementVille" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
            <label>
              <span>SIRET</span>
              <input type="text" formControlName="etablissementSiret" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Téléphone responsable</span>
                <input type="text" formControlName="etablissementNumResponsable" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Contact</span>
                <input type="text" formControlName="etablissementContact" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
          </details>

          <details class="form-section">
            <summary>L'intérimaire</summary>
            <label>
              <span>Nom complet</span>
              <input type="text" formControlName="candidatFullname" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Prénom</span>
                <input type="text" formControlName="candidatFirstname" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Nom</span>
                <input type="text" formControlName="candidatLastname" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
            <label>
              <span>Adresse</span>
              <input type="text" formControlName="candidatAdress" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Code postal</span>
                <input type="text" formControlName="candidatPostalCode" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Ville</span>
                <input type="text" formControlName="candidatVille" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
            <label>
              <span>Téléphone</span>
              <input type="text" formControlName="candidatTel" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Nationalité</span>
                <input type="text" formControlName="candidatNationality" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Date de naissance</span>
                <input type="date" formControlName="candidatBirthDay" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
            <label>
              <span>N° Sécurité Sociale</span>
              <input type="text" formControlName="candidatSocialSecurity" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
          </details>

          <details class="form-section">
            <summary>Collary</summary>
            <label>
              <span>Nom</span>
              <input type="text" formControlName="agencyName" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <label>
              <span>Adresse</span>
              <input type="text" formControlName="agencyAddress" [readonly]="missionContractSent || isCas1Doctor" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>SIRET</span>
                <input type="text" formControlName="agencySiret" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
              <label>
                <span>Téléphone</span>
                <input type="text" formControlName="agencyPhone" [readonly]="missionContractSent || isCas1Doctor" />
              </label>
            </div>
          </details>

          </div> <!-- end scrollable area -->

          <div class="actions" style="position: sticky; bottom: 0; background: white; padding: 10px 0; border-top: 1px solid #eee;">
            @if (isCas1Doctor) {
              <!-- Lot F — CAS 1 (client clinique) : contrat médecin généré et archivé automatiquement -->
              <span class="sent-notice" style="margin: 0;">✅ Contrat généré et archivé automatiquement (aucune signature requise)</span>
            }
            @if (!missionContractSent && !isCas1Doctor && canAct) {
            <button type="button" class="btn btn-secondary"
              [disabled]="savingMission || sendingMission"
              (click)="saveEdits('MISSION')">
              {{ savingMission ? 'Enregistrement...' : 'Enregistrer' }}
            </button>
            <button type="button" class="btn btn-primary"
              [disabled]="savingMission || sendingMission"
              (click)="validateAndSend('MISSION')">
              {{ sendingMission ? 'Envoi...' : 'Valider et envoyer' }}
            </button>
            }
            @if (!isCas1Doctor) {
            <button type="button" class="btn btn-tertiary"
              [disabled]="openingDocuSignMission || !missionContractSent"
              (click)="openInDocuSign('MISSION')">
              {{ openingDocuSignMission ? 'Ouverture...' : 'Voir dans DocuSign' }}
            </button>
            }
          </div>

        </div>

        <div class="right-pane">
          @if (loadingMissionPdf) {
            <div class="pdf-loader">Chargement du PDF...</div>
          } @else if (missionPdfSrc) {
            <embed [src]="missionPdfSrc" type="application/pdf" class="pdf-embed" />
          } @else {
            <div class="pdf-loader">Aucun aperçu disponible</div>
          }
        </div>
      </div>
    </mat-tab>

    <!-- Lot F (client clinique) : PAS DE CONTRAT DE MISE À DISPOSITION — onglet retiré de l'UI dans tous
         les cas (code conservé dans un @if(false)) -->
    @if (false) {
    <mat-tab>
      <ng-template mat-tab-label>
        Contrat de mise à disposition
        @if (dispositionContractSent) {
          <span class="sent-badge" title="Contrat envoyé">✓</span>
        }
      </ng-template>
      <div class="tab-body">
        <div class="left-pane" [formGroup]="dispositionForm" style="display: flex; flex-direction: column; min-height: 0;">
          <div style="flex: 1; overflow-y: auto; padding-bottom: 10px;">
          <h3>Modifier les informations du contrat</h3>

          @if (dispositionContractSent) {
            <div class="sent-notice">
              @if (dispositionContractSigned) {
                ✅ Ce contrat a été signé !
              } @else {
                ✅ Ce contrat a déjà été validé et envoyé.
              }
            </div>

            @if (!dispositionContractSigned) {
            <div class="reminder-panel">
              <div class="reminder-title">🔔 Rappels — Contrat de mise à disposition</div>
              <label class="reminder-toggle">
                <input type="checkbox" [(ngModel)]="dispositionReminderEnabled"
                  [ngModelOptions]="{standalone: true}" />
                <span>Rappels automatiques activés</span>
              </label>
              @if (dispositionReminderEnabled) {
                <div class="reminder-row">
                  <label class="reminder-interval">
                    <span>Prochain rappel dans</span>
                    <input type="number" min="1" max="720"
                      [(ngModel)]="dispositionNextSendInHours"
                      [ngModelOptions]="{standalone: true}"
                      class="interval-input" />
                    <span>h</span>
                  </label>
                  <span class="reminder-next-date">
                    ({{ getNextReminderDate('DISPOSITION') | date:'dd/MM HH:mm' }})
                  </span>
                </div>
              } 
              @if (dispositionReminderEnabled) {
              <!-- <div class="reminder-row">
                <label class="reminder-interval">
                  <span>Ensuite, toutes les</span>
                  <input type="number" min="1" max="720"
                    [(ngModel)]="dispositionReminderIntervalHours"
                    [ngModelOptions]="{standalone: true}"
                    class="interval-input" />
                  <span>h</span>
                </label>
              </div> -->
              }
              <div class="reminder-actions" *ngIf="canAct">
                <button type="button" class="btn btn-secondary btn-sm"
                  [disabled]="savingDispositionReminder"
                  (click)="saveReminderConfig('DISPOSITION')">
                  {{ savingDispositionReminder ? 'Sauvegarde...' : 'Enregistrer' }}
                </button>
                <button type="button" class="btn btn-primary btn-sm"
                  [disabled]="sendingDispositionReminder"
                  (click)="sendReminderNow('DISPOSITION')">
                  {{ sendingDispositionReminder ? 'Envoi...' : 'Envoyer maintenant' }}
                </button>
              </div>
              @if (dispositionLastReminderSentAt) {
              <div class="reminder-last-sent">
                Dernier rappel : {{ dispositionLastReminderSentAt | date:'dd/MM/yyyy HH:mm' }}
              </div>
              }
            </div>
            }
          }

          <details class="form-section" open>
            <summary>Mission</summary>
            <label>
              <span>Référence / Titre</span>
              <input type="text" formControlName="missionTitle" [readonly]="dispositionContractSent" />
            </label>
            <label>
              <span>Qualification (poste)</span>
              <input type="text" formControlName="missionTypeDePoste" [readonly]="dispositionContractSent" />
            </label>
            <label>
              <span>Rémunération nette proposée</span>
              <input type="number" formControlName="compensationproposednet" [readonly]="dispositionContractSent" />
            </label>
            <!-- Dates hidden in contract edition (UI HIDE ONLY per specs) -->
            <div class="row" style="margin: unset; display: none;">
              <label>
                <span>Date de début</span>
                <input type="date" formControlName="startdate" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Date de fin</span>
                <input type="date" formControlName="enddate" [readonly]="dispositionContractSent" />
              </label>
            </div>
            <div class="row" style="margin: unset;">
              <label>
                <span>Heure de début</span>
                <input type="time" formControlName="starttime" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Heure de fin</span>
                <input type="time" formControlName="endtime" [readonly]="dispositionContractSent" />
              </label>
            </div>
            <label>
              <span>Description</span>
              <textarea rows="3" formControlName="description" [readonly]="dispositionContractSent"></textarea>
            </label>
            <label>
              <span>Législation Rémunération</span>
              <textarea rows="5" formControlName="remunerationLegislation" [readonly]="dispositionContractSent"></textarea>
            </label>
          </details>

          <details class="form-section">
            <summary>Établissement utilisateur</summary>
            <label>
              <span>Nom</span>
              <input type="text" formControlName="etablissementName" [readonly]="dispositionContractSent" />
            </label>
            <label>
              <span>Adresse</span>
              <input type="text" formControlName="etablissementAdress" [readonly]="dispositionContractSent" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Code postal</span>
                <input type="text" formControlName="etablissementCodePostale" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Ville</span>
                <input type="text" formControlName="etablissementVille" [readonly]="dispositionContractSent" />
              </label>
            </div>
            <label>
              <span>SIRET</span>
              <input type="text" formControlName="etablissementSiret" [readonly]="dispositionContractSent" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Téléphone responsable</span>
                <input type="text" formControlName="etablissementNumResponsable" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Contact</span>
                <input type="text" formControlName="etablissementContact" [readonly]="dispositionContractSent" />
              </label>
            </div>
          </details>

          <details class="form-section">
            <summary>L'intérimaire</summary>
            <label>
              <span>Nom complet</span>
              <input type="text" formControlName="candidatFullname" [readonly]="dispositionContractSent" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Prénom</span>
                <input type="text" formControlName="candidatFirstname" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Nom</span>
                <input type="text" formControlName="candidatLastname" [readonly]="dispositionContractSent" />
              </label>
            </div>
            <label>
              <span>Adresse</span>
              <input type="text" formControlName="candidatAdress" [readonly]="dispositionContractSent" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>Code postal</span>
                <input type="text" formControlName="candidatPostalCode" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Ville</span>
                <input type="text" formControlName="candidatVille" [readonly]="dispositionContractSent" />
              </label>
            </div>
          </details>

          <details class="form-section">
            <summary>Collary</summary>
            <label>
              <span>Nom</span>
              <input type="text" formControlName="agencyName" [readonly]="dispositionContractSent" />
            </label>
            <label>
              <span>Adresse</span>
              <input type="text" formControlName="agencyAddress" [readonly]="dispositionContractSent" />
            </label>
            <div class="row" style="margin: unset;">
              <label>
                <span>SIRET</span>
                <input type="text" formControlName="agencySiret" [readonly]="dispositionContractSent" />
              </label>
              <label>
                <span>Téléphone</span>
                <input type="text" formControlName="agencyPhone" [readonly]="dispositionContractSent" />
              </label>
            </div>
          </details>

          </div> <!-- end scrollable area -->

          <div class="actions" style="position: sticky; bottom: 0; background: white; padding: 10px 0; border-top: 1px solid #eee;">
            @if (!dispositionContractSent && canAct) {
            <button type="button" class="btn btn-secondary"
              [disabled]="savingDisposition || sendingDisposition"
              (click)="saveEdits('DISPOSITION')">
              {{ savingDisposition ? 'Enregistrement...' : 'Enregistrer' }}
            </button>
            <button type="button" class="btn btn-primary"
              [disabled]="savingDisposition || sendingDisposition"
              (click)="validateAndSend('DISPOSITION')">
              {{ sendingDisposition ? 'Envoi...' : 'Valider et envoyer' }}
            </button>
            }
            @if (!isCas1Doctor) {
            <button type="button" class="btn btn-tertiary"
              [disabled]="openingDocuSignDisposition || !dispositionContractSent"
              (click)="openInDocuSign('DISPOSITION')">
              {{ openingDocuSignDisposition ? 'Ouverture...' : 'Voir dans DocuSign' }}
            </button>
            }
          </div>

        </div>

        <div class="right-pane">
          @if (loadingDispositionPdf) {
            <div class="pdf-loader">Chargement du PDF...</div>
          } @else if (dispositionPdfSrc) {
            <embed [src]="dispositionPdfSrc" type="application/pdf" class="pdf-embed" />
          } @else {
            <div class="pdf-loader">Aucun aperçu disponible</div>
          }
        </div>
      </div>
    </mat-tab>
    }
  </mat-tab-group>

  }
</div>
